import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { verifyVehicleDate } from '@allesauto/utils/funcs';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

interface CarDetailsProps {
  product: SchemaTypes.Vehicle | undefined;
  consumptionValue: string | undefined;
  emissionValue: string | undefined;
}

const useCarDetails = ({
  product,
  consumptionValue,
  emissionValue,
}: CarDetailsProps) => {
  const intl = useIntl();

  const carDetails = useMemo(() => {
    if (product) {
      return [
        {
          label: translate(intl, 'ui.SHOPPING_CART.CAR.MILEAGE'),
          value: product.mileage
            ? translate(intl, 'ui.UNITS.MILEAGE', {
                value: intl.formatNumber(product.mileage),
              })
            : undefined,
        },
        {
          label: translate(intl, 'ui.SHOPPING_CART.CAR.FIRST_REGISTRATION'),
          value: verifyVehicleDate(product.registeredIn),
        },
        {
          label: translate(intl, 'ui.SHOPPING_CART.CAR.PERFORMANCE'),
          value:
            product.powerKw && product.powerHp
              ? translate(intl, 'ui.UNITS.POWER_KW_HP', {
                  valueKW: intl.formatNumber(product.powerKw),
                  valueHP: intl.formatNumber(product.powerHp),
                })
              : undefined,
        },
        {
          label: translate(intl, 'ui.SHOPPING_CART.CAR.FUEL_TYPE'),
          value: product.fuelType || translate(intl, 'ui.COMMON.NOT_AVAILABLE'),
        },
        {
          label: translate(intl, 'ui.SHOPPING_CART.CAR.CONSUMPTION'),
          value: consumptionValue,
        },
        {
          label: translate(intl, 'ui.SHOPPING_CART.CAR.CO2_LABEL'),
          value: emissionValue,
        },
      ];
    }
  }, [consumptionValue, emissionValue, intl, product]);

  return carDetails;
};

export default useCarDetails;
